import React, { useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    generateFormikInitialValues,
    generateFormikValidationSchema,
    generateSteps,
    parseFieldVariables
} from "../../utils/dynamicFields";
import {ActFilling} from "../../components/ActFilling/ActFilling";
import {
    createErrorNotification,
    createInfoNotification,
    createSuccessNotification
} from "../../redux/reducers/notification-reducer";
import {useFormik} from "formik";
import {Statuses} from "../../utils/actStatuses";
import {RouteNames} from "../../router/consts";
import {useRedirect} from "../../hooks/useRedirect";
import { UserRoles } from '../../utils/roles';
import {getSelectedAct} from "../../redux/reducers/act-reducer";
const isErrorInSteps = (stepVariables, errors) => {
    const errorSteps = [false, false, false]

    for (const key of Object.keys(errors)) {
        if (stepVariables[0].find(f => f === key)) {
            errorSteps[0] = true
        }
        if (stepVariables[1].find(f => f === key)) {
            errorSteps[1] = true
        }
        if (stepVariables[2].find(f => f === key)) {
            errorSteps[2] = true
        }
    }
    return errorSteps
}

export const ActFillingContainer = ({
                                        selectedAct,
                                        actTemplate,
                                        handleCreateAct,
                                        handlePatchAct,
                                        handleCreateActLock,
                                        handlePatchActLock,
                                        selectedProject,
                                        activeEnvironmentState,
                                        user,
                                        youSupervisors,
                                    }) => {
    const dispatch = useDispatch()
    const {redirect} = useRedirect()


    const formikInitialValues = useMemo(() =>
            selectedAct ? selectedAct.raw_content : generateFormikInitialValues(actTemplate?.fieldTemplates),
        [actTemplate, selectedAct])

    const [formikValidationSchema, steps] = useMemo(() => [
        generateFormikValidationSchema(actTemplate?.fieldTemplates),
        generateSteps(actTemplate?.fieldTemplates)
    ], [actTemplate])
    const stepVariables = useMemo(() => steps.map(step => step.map(el => el.variable)), [steps])
    
    
    const [errorSteps, setErrorSteps] = useState([false, false, false])
    const [status, setStatus] = useState(selectedAct?.status)
    const Act = useSelector(getSelectedAct)
    const second = (act, stat) => {
        if (act?.content?.tbl_contents.length > 0) {
            if (stat) {
                return 1;
            }
            return 0;
        }
        return 0;
    }
    
    const [activeStep, setActiveStep] = useState(0)
    useEffect(() => {
        setActiveStep(second(Act, status))
    }, [Act, status])
    const [comments, setComments] = useState(selectedAct?.comments)
    const [files, setFiles] = useState(selectedAct?.files || [])
    const [supervisor, setSupervisor] = useState(selectedAct?.creator ? selectedAct?.creator : null)

    const {
        touched,
        values,
        errors,
        getFieldProps,
        setFieldValue,
        setFieldTouched,
        resetForm,
        setTouched,
        setErrors,
        validateForm
    } = useFormik({
        initialValues: formikInitialValues,
        validationSchema: formikValidationSchema
    })


    const nextStep = async () => {
        setActiveStep(prev => {
            if (prev !== 2) {
                return prev + 1
            }
        })
    }

    const prevStep = () => {
        setActiveStep(prev => {
            if (prev !== 0) {
                return prev - 1
            }
        })
    }


    const handleStatusChange = (e) => setStatus(e.target.value)

    const handleCommentsChange = (e) => setComments(e.target.value)

    const handleActScan = (newFiles) => setFiles(newFiles)

    const onCreateError = () => {
        dispatch(createErrorNotification('Пожалуйста, устраните ошибки, допущенные при заполнении акта'))
    }

    const onSave = () => {
        dispatch(createInfoNotification('Акт сохранен'))
    }

    const onCreate = () => {
        dispatch(createSuccessNotification('Акт успешно отправлен на проверку'))
    }

    const onApprove = () => {
        dispatch(createSuccessNotification('Акт успешно подтвержден'))
    }

    const onReject = () => {
        dispatch(createSuccessNotification('Акт отклонен'))
    }

    const onDeleteDraft = () => {
        dispatch(createInfoNotification('Черновик акта удален'))
    }

    const handleSaveActDraftButton = () => {
        const name = `${selectedProject.name}. ${new Date().toISOString()}`
        let content = parseFieldVariables(values, actTemplate?.fieldTemplates)
        const violations = typeof content[actTemplate.content.violationsVariable] === 'object' ? 
             content[actTemplate.content.violationsVariable]?.map(el => el.id) : null

        if (selectedAct) {
            handlePatchAct(selectedAct.id,
                {
                    content,
                    rawContent: values,
                    status: Statuses.IN_WORK_STATUS,
                    files: files,
                    violations
                })
        } else {
            handleCreateAct({
                name,
                content,
                rawContent: values,
                status: Statuses.IN_WORK_STATUS,
                environmentStateId: activeEnvironmentState.id,
                files: files,
                creatorId: user.id,
                violations
            })
        }
        onSave()
        resetForm()
        redirect(RouteNames.HOME)
    }

    const handleDeleteActDraftButton = () => {
        handlePatchAct(selectedAct?.id, {status: Statuses.DELETED_STATUS})
        onDeleteDraft()
        resetForm()
        redirect(RouteNames.HOME)
    }

    const handleCreateActButton = async () => {
        const errors = await validateForm()
        if (Object.keys(errors).length === 0) {
            const name = `${selectedProject.name}. ${new Date().toISOString()}`
            let content = parseFieldVariables(values, actTemplate?.fieldTemplates)
            const violations = typeof content[actTemplate.content.violationsVariable] === 'object' ? 
             content[actTemplate.content.violationsVariable]?.map(el => el.id) : null

            if (!selectedAct) {
                handleCreateAct({
                    name,
                    content,
                    rawContent: values,
                    status: Statuses.FOR_APPROVAL_STATUS,
                    environmentStateId: activeEnvironmentState.id,
                    files: files,
                    creatorId: user.role !== UserRoles.FIELD_CONTRACTOR ? user.id : supervisor.id,
                    field_contractor: user.role === UserRoles.FIELD_CONTRACTOR ? user.id : null,
                    violations
                })
            } else {
                handlePatchAct(selectedAct.id,
                    {
                        content,
                        rawContent: values,
                        status: Statuses.FOR_APPROVAL_STATUS,
                        files: files,
                        violations
                    })
            }
            onCreate()
            resetForm()
            redirect(RouteNames.HOME)
        } else {
            let touched = {}
            for (const field of Object.keys(errors)) {
                touched[field] = true
            }
            await setTouched(touched, false)
            await setErrors(errors)

            setErrorSteps(isErrorInSteps(stepVariables, errors))
            onCreateError()
        }
    }

    const handleCreateActButtonLock = async () => {
        const errors = await validateForm()
        if (Object.keys(errors).length === 0) {
            const name = `${selectedProject.name}. ${new Date().toISOString()}`
            let content = parseFieldVariables(values, actTemplate?.fieldTemplates)
            const violations = typeof content[actTemplate.content.violationsVariable] === 'object' ? 
             content[actTemplate.content.violationsVariable]?.map(el => el.id) : null

            if (!selectedAct) {
                handleCreateActLock({
                    name,
                    content,
                    rawContent: values,
                    status: 'signed',
                    environmentStateId: activeEnvironmentState.id,
                    files: files,
                    creatorId: user.id,
                    violations
                })
            } else {
                handlePatchActLock(selectedAct.id,
                    {
                        content,
                        rawContent: values,
                        status: 'signed',
                        files: files,
                        violations
                    })
            }
            onCreate()
            resetForm()
            redirect(RouteNames.HOME)
        } else {
            let touched = {}
            for (const field of Object.keys(errors)) {
                touched[field] = true
            }
            await setTouched(touched, false)
            await setErrors(errors)

            setErrorSteps(isErrorInSteps(stepVariables, errors))
            onCreateError()
        }
    }

    const handleAdminSaveButton = () => {
        const name = `${selectedProject.name}. ${new Date().toISOString()}`
        let content = parseFieldVariables(values, actTemplate?.fieldTemplates)
        const violations = typeof content[actTemplate.content.violationsVariable] === 'object' ? 
             content[actTemplate.content.violationsVariable]?.map(el => el.id) : null

        if (!selectedAct) {
            handleCreateAct({
                name,
                content,
                rawContent: values,
                status: status,
                environmentStateId: activeEnvironmentState.id,
                files: files,
                creatorId: user.id,
                comments,
                violations
            })
        } else {
            handlePatchAct(selectedAct.id,
                {
                    content,
                    rawContent: values,
                    status: status,
                    files: files,
                    comments,
                    violations
                })
        }
        onSave()
        resetForm()
        redirect(RouteNames.HOME)
    }

    const handleAdminSaveButtonLock = () => {
        const name = `${selectedProject.name}. ${new Date().toISOString()}`
        let content = parseFieldVariables(values, actTemplate?.fieldTemplates)
        
        const violations = typeof content[actTemplate.content.violationsVariable] === 'object' ? 
             content[actTemplate.content.violationsVariable]?.map(el => el.id) : null

        if (!selectedAct) {
            handleCreateActLock({
                name,
                content,
                rawContent: values,
                status: 'signed',
                environmentStateId: activeEnvironmentState.id,
                files: files,
                creatorId: user.id,
                comments,
                violations
            })
        } else {
            handlePatchActLock(selectedAct.id,
                {
                    content,
                    rawContent: values,
                    status: 'signed',
                    files: files,
                    comments,
                    violations
                })
        }
        onSave()
        resetForm()
        redirect(RouteNames.HOME)
    }

    const handleActApproveButton = () => {
        handlePatchAct(selectedAct.id, {
            status: Statuses.APPROVED_STATUS,
            comments: ''
        })
        onApprove()
        redirect(RouteNames.HOME)
    }

    const handleActRejectButton = () => {
        handlePatchAct(selectedAct.id, {
            status: Statuses.REJECTED_STATUS,
            comments
        })
        onReject()
        redirect(RouteNames.HOME)
    }

    if (!actTemplate) {
        return null
    }
    
    return <ActFilling steps={steps}
                       id={selectedAct?.id}
                       name={selectedProject?.name}
                       activeStep={activeStep}
                       errorSteps={errorSteps}
                       nextStep={nextStep}
                       prevStep={prevStep}
                       touched={touched}
                       errors={errors}
                       getFieldProps={getFieldProps}
                       setFieldValue={setFieldValue}
                       setFieldTouched={setFieldTouched}
                       selectedAct={selectedAct}
                       actTemplate={actTemplate}
                       status={status}
                       comments={comments}
                       user={user}
                       creator={selectedAct?.creator}
                       files={files}
                       handleStatusChange={handleStatusChange}
                       handleCommentsChange={handleCommentsChange}
                       handleActScan={handleActScan}
                       handleSaveActDraftButton={handleSaveActDraftButton}
                       handleCreateActButton={handleCreateActButton}
                       handleAdminSaveButton={handleAdminSaveButton}
                       handleActApproveButton={handleActApproveButton}
                       handleActRejectButton={handleActRejectButton}
                       handleDeleteActDraftButton={handleDeleteActDraftButton}
                       values={values}
                       handleAdminSaveButtonLock={handleAdminSaveButtonLock}
                       handleCreateActButtonLock={handleCreateActButtonLock}
                       supervisor={supervisor}
                       setSupervisor={setSupervisor}
                       youSupervisors={youSupervisors}
    />
}